
export async function getFiscalData(fiscalDataRepository) {
  return fiscalDataRepository.get()
}

